import { Injectable } from '@angular/core';
import { DocumentReference, deleteDoc, setDoc } from '@angular/fire/firestore';
import { AuthService } from '@auth';
import { FirestoreService } from '@core';
import { AgGridCommonFilterViewItem } from '@shared/models/ag-grid-common-filter.model';
import { CollectionReference, query } from 'firebase/firestore';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgGridCommonFilterService {

  saveChanges$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  AllFilters$: Subject<AgGridCommonFilterViewItem[]> = new Subject<AgGridCommonFilterViewItem[]>();

  constructor(
    private authService: AuthService,
    private firestoreService: FirestoreService
  ) { }

  loadAgGridFilterView(currentPageName: string) {
    const queryFn = query(this.firestoreService.col<AgGridCommonFilterViewItem>(`TableFilterViews/${this.authService.currentTenant}/${currentPageName}`));
    this.firestoreService.getCollectionWithDocIdAsync<AgGridCommonFilterViewItem>(queryFn).then((filters) => {
      this.AllFilters$.next(filters);
    });
  }

  addAgGridFilterView(data: AgGridCommonFilterViewItem) {
    return this.firestoreService.addDoc(this.getAgGridFilterViewDocumentsCollection(data.pageName!), data);
  }

  saveAgGridFilterView(data: AgGridCommonFilterViewItem) {
    const docRef = this.getAgGridCommonFilterViewItem(data.pageName!, data.docId!);
    return this.firestoreService.settleWrite(() => setDoc(docRef, data), docRef.path);
  }

  updateAgGridFilterView(data: AgGridCommonFilterViewItem) {
    const docRef = this.getAgGridCommonFilterViewItem(data.pageName!, data.docId!);
    return this.firestoreService.settleWrite(() => setDoc(docRef, data, { merge: true }), docRef.path);
  }

  deleteAgGridFilterView(data: AgGridCommonFilterViewItem) {
    const docRef = this.getAgGridCommonFilterViewItem(data.pageName!, data.docId!);
    return this.firestoreService.settleWrite(() => deleteDoc(docRef), docRef.path);
  }

  private getAgGridFilterViewDocumentsCollection(currentPageName: string): CollectionReference<AgGridCommonFilterViewItem> {
    return this.firestoreService.col(`TableFilterViews/${this.authService.currentTenant}/${currentPageName}`);
  }

  private getAgGridCommonFilterViewItem(currentPageName: string, docId: string): DocumentReference<AgGridCommonFilterViewItem> {
    return this.firestoreService.doc(`TableFilterViews/${this.authService.currentTenant}/${currentPageName}/${docId}`);
  }
}
